import http from 'hub-http/clients/apiClient';
const BASE_URL = '/forms/v2';
export const getFormsDetailsForComparison = ({
  guid,
  startDate,
  endDate
}) => http.get(`${BASE_URL}/dashboard/comparison/items`, {
  query: {
    startDate,
    endDate,
    formGuids: guid
  }
});